import {BaseModule} from '../../js/usga.base-module';
import {usgaUtils} from '../../js/usga.utils';
import Juicebox from 'juicebox';
import 'vendors/juicebox/juicebox.url.css';
import './gallery.url.less'

export const Gallery = BaseModule.extend({

	gallery: null,
	expanded: false,

	toggleExpand: function () {
		this.expanded = !this.expanded;
		if (this.gallery) {
			this.gallery.toggleExpand();
		}
	},

	trackDtmGallery: function (title) {
		if (title) {
			usgaUtils.trackDtm('photo-gallery-launch', {
				photogallery: {
					name: title
				}
			});
		}
	},

	trackDtmPhoto: function (title) {
		if (title) {
			usgaUtils.trackDtm('photo-gallery-image-view', {
				photo: {
					name: title
				}
			});
		}
	},

	onFirstShow: function () {
		if (this.options.showFullScreen) {
			window.location.replace("#expanded");
		}
		setTimeout(() => {
			this.onGalleryLoad();
		}, 0);
		this.trackDtmGallery(this.options.title);
	},

	onGalleryLoad: function () {
		this.gallery = new Juicebox({
			containerId: this.$element.attr('id'),
			configUrl: this.options.items,
			screenMode: 'large',
			enableLooping: true,
			thumbWidth: 128,
			thumbHeight: 72,
			galleryTitle: '',
			thumbFrameColor: 'rgba(101,104,107,.9)',
			thumbSelectedFrameWidth: '6',
			backgroundColor: '2a2e34',
			showOpenButton: false,
			showAutoPlayButton: false,
			showThumbsOnLoad: false,
			showThumbsButton: true,
			showImageOverlay: 'always',
			expandInNewPage: false,
			buttonBarPosition: 'top', // overlay, overlay_image, top, none
			buttonBarIconSize: '15',
			captionPosition: 'bottom', // overlay, overlay_image, below_image, bottom, below_thumbs, none
			themeUrl: '#juicebox.css' //workaround. real css include to general css file
		});
		this.gallery.onImageChange = this.proxy(this.onImageShow);
		if (this.expanded) {
			this.gallery.toggleExpand();
		}
	},

	onImageShow: function (e) {
		var imageInfo = this.gallery.getImageInfo(e.id);

		this.trackDtmPhoto(imageInfo.title || imageInfo.id);
	}

});
